<!-- eslint-disable vue/multi-word-component-names -->
<script setup lang="ts">
import ForgotPasswordView from '../../auth/components/ForgotPasswordView.vue'

definePage({
    meta: {
        isGuest: true,
    }
})
</script>

<template>
  <ForgotPasswordView />
</template>